import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router'
import { Spin } from 'antd';
import { Header } from '../../../components/Header/Header'
import Project from '../../project'
import Lineitems from '../../lineItems'

class Dashboard extends Component {

  componentDidMount() {
    this.props.actions.loadUserInfo();
  }
  
  render() {
    const { settings, history, userinfo} = this.props;
    if (userinfo) {
      return (
        <div className="root-container">
          <Header 
            settings={settings}
            history={history}
            logoutUser={this.props.actions.logoutUser}
            userinfo={userinfo}
          />
          <Switch>
            <Redirect exact from='/dashboard' to='/dashboard/lineitems' />
            <Route path='/dashboard/project/:projectUUID/lineItem/:lineItemUUID' component={Project} />
            <Route path='/dashboard/lineitems' component={Lineitems} />
          </Switch>
        </div>
      )
    } else {
      return <Spin className="spin-container" />
    }
  }
}

export default Dashboard